<template>
  <v-app class="bg-lightBlue">
    <v-container>
      <v-row class="justify-start">
        <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="d-inline-flex primary--text">
            <h2 class="text-md-left primary--text">
              {{ $t('dateBank.title') }}
            </h2>
          </div>
        </v-col>
      </v-row>
      <v-form v-model="isFormValid">
        <v-row class="justify-center">
          <v-col class="col-12 col-md-9">
            <v-row class="justify-center">
              <v-col class="col-12 col-md-9">
                <div class="bg-secondaryGray br-8 pa-5">
                  <h2 class="primary--text text-center f-1">Dados Bancários</h2>
                </div>
              </v-col>
            </v-row>
            <v-row class="justify-center" v-if="lang === 'pt'">
              <v-col class="col-12 col-md-9 pb-0">
                <v-select
                  :items="empresa_eni"
                  :label="selectType"
                  v-model="empresaOuEni"
                  :rules="rules"
                  required
                  solo
                  flat
                  background-color="#F7F7F7"
                  @change="resetForm"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="justify-center" v-if="empresaOuEni === 'company'">
              <v-col class="col-12 col-md-9 pt-0">
                <v-text-field
                  filled
                  label="Digite o nome da empresa"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="nome"
                ></v-text-field>

                <v-text-field
                  filled
                  label="Digite aqui seu telefone"
                  required
                  v-mask="'+### ### ### ###'"
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="telefone"
                ></v-text-field>

                <v-text-field
                  filled
                  label="Digite o representante da empresa"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="representanteEmpresa"
                ></v-text-field>

                <v-text-field
                  filled
                  label="Digite o código Postal"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="codigoPostal"
                ></v-text-field>
                <v-text-field
                  filled
                  :label="$t('dateBank.numberAccount')"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="codigoIban"
                ></v-text-field>

                <v-text-field
                  filled
                  :label="$t('dateBank.identifyNumber')"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="numeroVatOuInf"
                ></v-text-field>

                <v-text-field
                  filled
                  label="Seu endereço"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="endereco"
                ></v-text-field>
                <v-file-input
                  solo
                  flat
                  label="Comprovante de Endereço do titular"
                  :prepend-icon="null"
                  required
                  background-color="#fff"
                  height="100"
                  class="input-banco input-banco-nexo"
                  hide-details="auto"
                  :rules="rules"
                  v-model="comprovanteEndereco"
                >
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" class="mb-1" medium>
                          description
                        </v-icon>
                        <span class="text-decoration-underline">
                          Comprovante de endereço do títular
                        </span>
                      </p>
                    </div>
                  </template>
                </v-file-input>

                <v-file-input
                  solo
                  flat
                  :prepend-icon="null"
                  required
                  background-color="#fff"
                  class="input-banco input-banco-identidade"
                  hide-details="auto"
                  :rules="rules"
                  v-model="comprovanteIdentidade"
                >
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" class="mb-1" medium>
                          description
                        </v-icon>
                        <span class="text-decoration-underline">
                          Comprovante de documento de identidade
                        </span>
                      </p>
                    </div>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
            <v-row
              class="justify-center"
              v-if="empresaOuEni === 'eni' || empresaOuEni === 'individual'"
            >
              <v-col class="col-12 col-md-9 pt-0">
                <v-text-field
                  filled
                  label="Digite seu nome"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="nome"
                ></v-text-field>

                <v-text-field
                    filled
                    :label="$t('dateBank.yourAddress')"
                    required
                    class="input-banco"
                    hide-details="auto"
                    :rules="rules"
                    v-model="endereco"
                    v-if="lang === 'pt-BR'"
                  ></v-text-field>

                <v-text-field
                  filled
                  label="Digite aqui seu telefone"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-mask="numberMask"
                  v-model="telefone"
                ></v-text-field>

                <v-text-field
                  filled
                  label="Digite o código Postal"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-mask="codigoPostalMask"
                  v-model="codigoPostal"
                ></v-text-field>

                <template v-if="lang === 'pt-BR'">
                  <v-select
                    :items="banks"
                    label="Banco"
                    v-model="bankNumber"
                    item-value="value"
                    :rules="rules"
                    required
                    flat
                    filled
                    hide-details="auto"
                  ></v-select>

                  <v-text-field
                    filled
                    label="Número da agência (sem o dígito)"
                    required
                    class="input-banco"
                    hide-details="auto"
                    :rules="rules"
                    v-model="agencyNumber"
                  ></v-text-field>
                </template>

                <v-text-field
                  filled
                  :label="$t('dateBank.numberAccount')"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="codigoIban"
                ></v-text-field>

                <v-text-field
                  filled
                  :label="$t('dateBank.identifyNumber')"
                  required
                  class="input-banco"
                  hide-details="auto"
                  :rules="rules"
                  v-model="numeroVatOuInf"
                ></v-text-field>

                <v-row
                  class="justify-center pa-3 align-center"
                  v-if="lang === 'pt-BR'"
                >
                  <v-col cols="11" class="pa-0">
                    <v-select
                      :items="exposed_policy"
                      :label="selectTypePolicy"
                      v-model="isExposedPolicy"
                      :rules="rules"
                      item-value="value"
                      required
                      flat
                      solo
                      filled
                      hide-details="auto"
                      background-color="#F7F7F7"
                    />
                  </v-col>
                  <v-col
                    cols="1"
                    class="pa-0 justify-center align-center d-flex"
                  >
                    <a
                      href="https://support.stripe.com/questions/defining-political-exposure-in-brazil"
                      class="d-flex align-center"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="../../../assets/info-red.svg"
                        width="20"
                        height="20"
                      />
                    </a>
                  </v-col>
                </v-row>

                <template v-if="lang === 'pt'">
                  <v-text-field
                    filled
                    :label="$t('dateBank.yourAddress')"
                    required
                    class="input-banco"
                    hide-details="auto"
                    :rules="rules"
                    v-model="endereco"
                  ></v-text-field>
                  <v-file-input
                    solo
                    flat
                    label="Comprovante de Endereço do titular"
                    :prepend-icon="null"
                    required
                    background-color="#fff"
                    height="100"
                    class="input-banco input-banco-nexo"
                    hide-details="auto"
                    :rules="rules"
                    v-model="comprovanteEndereco"
                  >
                    <template v-slot:label>
                      <div>
                        <p class="ma-0 labelGray--text">
                          <v-icon color="labelGray" class="mb-1" medium>
                            description
                          </v-icon>
                          <span class="text-decoration-underline">
                            Comprovante de endereço do títular
                          </span>
                        </p>
                        <!-- <p
                          class="ma-0 ml-1 text-body-2 font-italic"
                          color="primary"
                        >
                          Ex: passaporte, documento de identidade<br />
                          oficial,conta de água, luz ou telefone.
                        </p> -->
                      </div>
                    </template>
                  </v-file-input>
                </template>
                <v-file-input
                  solo
                  flat
                  :label="$t('dateBank.identityDocument')"
                  :prepend-icon="null"
                  required
                  background-color="#fff"
                  height="100"
                  class="input-banco input-banco-nexo"
                  hide-details="auto"
                  :rules="rules"
                  v-model="comprovanteEndereco"
                  v-if="lang === 'pt-BR'"
                >
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" medium> description </v-icon>
                        <span class="text-decoration-underline">
                          {{ $t('dateBank.identityDocument') }}
                        </span>
                      </p>
                    </div>
                  </template>
                </v-file-input>

                <v-file-input
                  solo
                  flat
                  :prepend-icon="null"
                  required
                  background-color="#fff"
                  class="input-banco input-banco-identidade"
                  hide-details="auto"
                  :rules="rules"
                  v-model="comprovanteIdentidade"
                >
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" class="mb-1" medium>
                          description
                        </v-icon>
                        <span class="text-decoration-underline">
                          {{ $t('dateBank.identityDocument') }}
                        </span>
                      </p>
                    </div>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-flex flex-column align-center justify-center mt-5">
        <v-btn
          large
          color="secondary"
          :disabled="!isFormValid || isLoading"
          :loading="isLoading"
          @click="createBankAccount"
          style="align-self: center"
          >Registar</v-btn
        >
        <v-btn
          class="mt-3"
          text
          style="align-self: center"
          @click="$router.replace('/psicologo/dashboard')"
          >Cancelar</v-btn
        >
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import {
  createBankAccount,
  getProfile,
  uploadStripeDocument,
} from '../../../services/psychologists';
import i18n from '../../../plugins/i18n';
import getLanguage from '../../../utils/getLanguage';
import { padWithZeroes } from '../../../utils';

export default {
  data() {
    return {
      empresaOuEni: '',
      isFormValid: false,
      empresa_eni: [
        {
          text: i18n.t('dateBank.types.firstType'),
          value: 'company',
        },
        {
          text: i18n.t('dateBank.types.secondType'),
          value: 'eni',
        },
      ],
      exposed_policy: [
        {
          text: 'Sim',
          value: 'existing',
        },
        {
          text: 'Não',
          value: 'none',
        },
      ],
      banks: [],
      nome: '',
      representanteEmpresa: '',
      codigoPostal: '',
      telefone: '',
      codigoIban: '',
      numeroVatOuInf: '',
      endereco: '',
      comprovanteEndereco: null,
      comprovanteIdentidade: null,
      isLoading: false,
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      stripeVariables: null,
      lang: '',
      selectType: '',
      selectTypePolicy: '',
      bankNumber: '',
      agencyNumber: '',
      numberMask: '',
      codigoPostalMask: '',
      isExposedPolicy: ''
    };
  },
  directives: {
    mask,
  },
  created() {
    this.checkUserbankAccount();
    this.lang = getLanguage(window.location.href);
    this.selectType = `${i18n.t('dateBank.types.firstType')} ou ${i18n.t(
      'dateBank.types.secondType',
    )}`;
    this.selectTypePolicy = 'Exposição politica ?';
    if (this.lang === 'pt-BR') this.empresaOuEni = 'individual';
    if (this.lang === 'pt') {
      this.numberMask = '+### ### ### ###';
      this.codigoPostalMask = '####-###';
    } else {
      this.numberMask = '+## (##) # ########';
      this.codigoPostalMask = '##.###-###';
    }
    this.getBankArray();
  },
  mounted() {
    this.stripeVariables = this.lang === 'pt-BR' ? process.env.VUE_APP_STRIPE_KEY_BR : process.env.VUE_APP_STRIPE_KEY;
  },
  methods: {
    async checkUserbankAccount() {
      const localUser = JSON.parse(localStorage.getItem('user-data'));
      const user = await getProfile(localUser.id);
      if (user.digital_account != null) {
        this.$router.replace('/psicologo/');
        this.$showSnackbar(
          'Você já possui uma conta bancária e não pode modificar.',
        );
      }
    },
    async getBankArray() {
      const { data } = await axios.get('https://brasilapi.com.br/api/banks/v1');
      this.banks = data
        .filter((bank) => bank.code)
        .sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        })
        .map((bank) => ({
          text: bank.name,
          value: bank.code,
        }));
    },
    async createBankAccount() {
      this.isLoading = true;
      const retornoStripeFileEndereco = await uploadStripeDocument(
        this.comprovanteEndereco,
        this.stripeVariables,
        'additional_verification',
      );

      const retornoStripeFileIdentidade = await uploadStripeDocument(
        this.comprovanteIdentidade,
        this.stripeVariables,
        'identity_document',
      );
      const dataFormIndividual = new FormData();
      dataFormIndividual.append(
        'file_additional_verification',
        retornoStripeFileEndereco,
      );
      dataFormIndividual.append(
        'file_identity_document',
        retornoStripeFileIdentidade,
      );
      dataFormIndividual.append('name', this.nome);
      dataFormIndividual.append('type_account', this.empresaOuEni);
      dataFormIndividual.append(
        'company_representative',
        this.representanteEmpresa,
      );
      const routingNumber = `${padWithZeroes(this.bankNumber, 3)}-${this.agencyNumber}`;
      dataFormIndividual.append('zip_code', this.codigoPostal);
      dataFormIndividual.append('phone', this.telefone);
      dataFormIndividual.append('iban_code', this.codigoIban);
      dataFormIndividual.append('vat_number', this.numeroVatOuInf);
      dataFormIndividual.append('street', this.endereco);
      dataFormIndividual.append('routing_number', routingNumber);
      dataFormIndividual.append('political_exposure', this.isExposedPolicy);

      const dataFormCompany = {
        type_account: this.empresaOuEni,
        name: this.nome,
        company_representative: this.representanteEmpresa,
        zip_code: this.codigoPostal,
        phone: this.telefone,
        iban_code: this.codigoIban,
        vat_number: this.numeroVatOuInf,
        street: this.endereco,
        file_additional_verification: retornoStripeFileEndereco,
        file_identity_document: retornoStripeFileIdentidade,
        // routing_number: routingNumber,
        routing_number: '',
        political_exposure: this.isExposedPolicy,
        bank: {},
        personal: {},
        company: {},
      };
      try {
        if (this.empresaOuEni == 'individual') {
          await createBankAccount(dataFormIndividual);
        } else {
          await createBankAccount(dataFormCompany);
        }
        this.$showSnackbar('Cadastro bancário realizado com sucesso.');
        this.$router.push('/psicologo/profile');
      } catch (error) {
        this.$showSnackbar(error[0]);
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.nome = '';
      this.representanteEmpresa = '';
      this.codigoPostal = '';
      this.telefone = '';
      this.codigoIban = '';
      this.numeroVatOuInf = '';
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .input-banco .v-input__slot {
  height: 60px;
}

* >>> .input-banco .v-label {
  height: auto;
}

* >>> .v-file-input__text {
  height: 70px !important;
  cursor: pointer !important;
}
* >>> .input-banco {
  border-radius: 0;
}

* >>> .input-banco-nexo .v-label {
  overflow: visible !important;
  text-overflow: ellipsis !important;
  top: calc(50% - 34px) !important;
}

* >>> .input-banco-identidade .v-label {
  overflow: visible !important;
  text-overflow: ellipsis !important;
  top: calc(50% - 13px) !important;
}

/* * >>> .input-banco input {
  text-align: center;
} */

/* * >>> .input-banco .v-label {
  max-width: 100%;
  width: 100%;
  text-align: center;
} */

.input-banco:first-of-type {
  border-top: 1px solid #ccc;
}

.input-banco {
  border-bottom: 1px solid #ccc;
}
</style>
